import { CoreLogService } from "../log.service";
export interface PhoneCall {
  dial(number: string, onError: (err: string) => void, onSuccess: (err: string) => void);
  call(number: string, onError: (err: string) => void, onSuccess: (err: string) => void, appChooser: boolean);
}

export class PhoneCallDefault implements PhoneCall {

  constructor(private _coreLogService: CoreLogService) { }

  /**
   * Enables Cordova apps on the iPhone and Android platforms to dial a phone number without requireing additional user
   * interaction (such as the 'Call / Cancel' popup that ordinarilly would occur when using window.location.href = "tel:2125551212".
   * Required CALL_PHONE Permission for Android 5+ Version Apps.
   * @param number Phone Number.
   * @param onError Callback Function for handeling Error.
   * @param onSuccess Callback Function for handeling when phone call is successful.
   */
  public dial(number: string, onError: (err: string) => void, onSuccess: (err: string) => void) {
    const me = this;
    try {
      cordova.plugins["phonedialer"].dial(
        number,
        onError,
        onSuccess);
    } catch (error) {
      me._coreLogService.error("PhoneCall.dial", "dial function try catch", error);
    }
  }

  /**
  * Enables Cordova apps on the iPhone and Android platforms to call a phone number without requireing additional user
  * interaction (such as the 'Call / Cancel' popup that ordinarilly would occur when using window.location.href = "tel:2125551212".
  * Required CALL_PHONE Permission for Android 5+ Version Apps.
  * @param number Phone Number.
  * @param onError Callback Function for handeling Error.
  * @param onSuccess Callback Function for handeling when phone call is successful.
  * @param appChooser AppChooser for ByPass the Default App.
  */
  public call(number: string, onError: (err: string) => void, onSuccess: (err: string) => void, appChooser: boolean) {
    const me = this;
    try {
      cordova.plugins["phonedialer"].call(
        number,
        onError,
        onSuccess,
        appChooser
      );
    } catch (error) {
      me._coreLogService.error("PhoneCall.call", "call function try catch", error);
    }
  }
}
